import { render, staticRenderFns } from "./ManageGemsPlanModal.vue?vue&type=template&id=4ed43cc6&"
import script from "./ManageGemsPlanModal.vue?vue&type=script&lang=js&"
export * from "./ManageGemsPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports